<template>
  <div class="consultApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='7'></headComponent>
    <div class="h"></div>
    <img class="banners" src="~assets/images/banner-contact.png">
    <div class="consultcon">
      <div class="lx">
        <img class="logo" src="~assets/images/logo.png">
        <h3>0771-5383552</h3>
        <p>邮箱：CLKJ@zhjtg.com</p>
        <p>地址：广西钦州市钦南区大番坡镇金窝工业园区一期</p>
        <p style="padding-top:80px;position: relative;">微信公众号<br>扫一扫关注公众号，获取专业信息<img style="width:130px;position: absolute;right:0;top:38%" src="~assets/images/code.jpg"></p>
        
      </div>
      <div class="txt">
        <h2>业务咨询</h2>
        <ul>
          <li><input v-model="name" type="text" placeholder="您的称呼：（必填）"></li>
          <li><input v-model="phone" type="text" placeholder="联系方式：（必填）"></li>
          <li><input v-model="unit" type="text" placeholder="单位名称：（必填）"></li>
          <li>
            <textarea v-model="remark" placeholder="您的需求和建议："></textarea>
          </li>
          <li style="background:none">
            <p>请提交您的信息，我们将尽快与您联系</p>
            <a @click="save">提交信息</a>
          </li>
        </ul>
      </div>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        name:'',
        phone:'',
        unit:'',
        remark:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      save:function(){
        var that = this;
        if(that.name == ''){
          that.$alert('请输入称呼', '提示');
          return false;
        }
        if(that.phone == ''){
          that.$alert('请输入联系方式', '提示');
          return false;
        }
        if(that.unit == ''){
          that.$alert('请输入单位名称', '提示');
          return false;
        }
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/save',
          data:{
            name:that.name,
            phone:that.phone,
            unit:that.unit,
            remark:that.remark
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.name = '';
              that.phone = '';
              that.unit = '';
              that.remark = '';
              that.$alert(data.message, '提示');
            }else{
              that.$alert(data.message, '提示');
            }
            that.fullscreenLoading = false;
          }
        })
      }
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .consultApp .el-message-box{
    width:30%
  }
  .consultApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .consultApp .h{
    height:96px
  }
  .banners{
    display:block;
    width:100%
  }
  .consultApp .consultcon{
    max-width:1400px;
    margin:0 auto;
    min-height:700px;
    background:#fff;
    position: relative;
    top:-85px
  }
  .consultApp .consultcon .lx{
    width:calc(35% - 96px);
    float:left;
    background-color: #F2F2F2;
    padding: 50px 48px 27px 48px;
    min-height:623px;
  }
  .consultApp .consultcon .lx .logo{
    display:block;
    width:300px
  }
  .consultApp .consultcon .lx h3{
    font-size: 36px;
    font-family: 'Montserrat-Bold';
    color: #01248C;
    padding-top:30px;
  }
  .consultApp .consultcon .lx p{
    font-size: 16px;
    font-family: 'Montserrat-Bold';
    color:#333;
    padding-top:30px;
    line-height:30px
  }
  .consultApp .consultcon .txt{
    width:58%;
    float:right;
    margin-right:2%
  }
  .consultApp .consultcon h2{
    text-align:center;
    font-size:32px;
    padding:30px 0
  }
  .consultApp .consultcon ul li {
    background:#F2F2F2;
    width:96%;
    margin:0 auto 12px auto;
  }
  .consultApp .consultcon ul li input{
    display:block;
    width:calc(100% - 24px);
    height:55px;
    border:none;
    outline:none;
    background:none;
    font-size:18px;
    padding: 0 12px
  }
  .consultApp .consultcon ul li textarea{
    height:100px;
    width:calc(100% - 24px);
    display:block;
    font-size:18px;
    border:none;
    outline:none;
    padding: 12px;
    background:none;
    resize:none
  }
  .consultApp .consultcon ul li p{
    font-size: 14px;
    color: #333333;
    text-align: center;
    margin: 30px 0 12px 0;
  }
  .consultApp .consultcon ul li a{
    display: block;
    font-size: 16px;
    color: #fff;
    width: 100%;
    padding: 16px 0;
    background-color: #01248C;
    margin: 0 auto;
    cursor: pointer;
    text-align:center;
  }
  
  @media only screen and (max-width: 1199px) {
    .consultApp .header,.consultApp .h{
      height:60px;
    }
    .consultApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .consultApp .header .nav{
      text-align:right
    }
    .consultApp .header .nav li{
      margin:0 1.8vw
    }
    .consultApp .header .nav .close{
      display:none
    }
    .consultApp .header .nav a{
      line-height:60px;
      font-size:14px
    }
    .consultApp .consultcon .lx{
      display:none
    }
    .consultApp .consultcon .txt{
      width:96%
    }
    .consultApp .consultcon{
      top:-12px
    }
  } 
</style>